// ************************************ REQUIREMENTS
export const notBlankTextRequirements = new RegExp(/^[^<>{}\/]+$/);
export const emailRequirements = new RegExp(
  /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/,
);

// ************************************ TYPES
export type SelectedAccountType = "Basic" | "Trial" | "Member";

export interface CreateAccountFormValues {
  selectedAccountType: SelectedAccountType;
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  confirmPassword: string;
  termsandprivacy: boolean;
}

export interface SelectedSubscriptionMeta {
  accessType: "per-subject" | "all-access";
  currency: "gbp" | "usd" | "eur";
  billingPeriod: string; // e.g., "month-1", "year-1"
  items: SubscriptionItem[]; // array of items to add to subscription
}

// Represents a single subscription item (price + subject)
export interface SubscriptionItem {
  priceId: string;
  subjectDocumentIds: string[]; // the subject documentIds this price grants access to
  unitAmount: number; // price amount for this item
}

export interface MembershipFormValues {
  accessType: "per-subject" | "all-access" | "";
  selectedSubjects: string[]; // subject documentIds
  currency: "gbp" | "usd" | "eur";
  billingPeriod: string; // e.g., "month-1", "year-1"
}
